// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2sAGN","inner":"Footer_inner__x7Yk4"};